import { css } from "@stubhub/broadway-foundation/css";

export const topSubcategoriesListStyles = {
  image: css({
    filter: "[brightness(0.70)]",
  }),
} as const;
